<template>
  <div>
    <h3>Fieldwork Requests{{type === 'search' ? ' Search' : ''}}</h3>
    <form  v-if="type ==='search'" @submit.prevent="loadData" class="form-horizontal">
        <div class="form-group">
            <div class="col-sm-2">
                <label for="searchDbNumber">DB Number</label>
            </div>
            <div class="col-sm-2">
                <input class="form-control" type="text" name="searchDbNumber" v-model="searchDto.dbNumber">
            </div>
            <div class="col-sm-2 col-sm-offset-1">
                <label for="searchProjectName">Project Name</label>
            </div>
            <div class="col-sm-5">
                <input class="form-control" type="text" name="searchProjectName" v-model="searchDto.projectName">
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-2">
                <label for="searchAgencyProjectNumber">Agency Project No.</label>
            </div>
            <div class="col-sm-2">
                <input class="form-control" type="text" name="searchAgencyProjectNumber" v-model="searchDto.agencyProjectNumber">
            </div>
            <div class="col-sm-2 col-sm-offset-1">
                <label for="searchAgencyName">Agency Name</label>
            </div>
            <div class="col-sm-5">
                <select name="searchAgencyName" class="form-control" v-model="searchDto.agencyName">
                    <option value="">Select Agency Name</option>
                    <option v-for="organization in leadOrganizationList" :key="organization.organizationId" :value="organization.description">{{ organization.description}}</option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-2">
                <label for="searchFieldOrgProjectNumber">Field Org. Project No.</label>
            </div>
            <div class="col-sm-2">
                <input class="form-control" type="text" name="searchFieldOrgProjectNumber" v-model="searchDto.fieldOrgProjectNumber">
            </div>
            <div class="col-sm-2 col-sm-offset-1">
                <label for="searchFieldOrgName">Field Org. Name</label>
            </div>
            <div class="col-sm-5">
                <select name="searchFieldOrgName" class="form-control" v-model="searchDto.fieldOrgName">
                    <option value="">Select Field Organization Name</option>
                    <option v-for="organization in organizationList" :key="organization.organizationId" :value="organization.description">
                        {{ organization.description}}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-2">
                <label for="searchProjectType">Project Type</label>
            </div>
            <div class="col-sm-3">
                <input class="form-control" type="text" name="searchProjectType" v-model="searchDto.projectType">
            </div>
            <div class="col-sm-2">
                <label for="searchFieldOrgName">Requested Date Range</label>
            </div>
            <div class="col-sm-2">
                <el-date-picker v-model="searchDto.startDate" type="date" format="MM/dd/yyyy" placeholder="From Date"></el-date-picker>
            </div>
            <div class="col-sm-2">
                <el-date-picker v-model="searchDto.endDate" type="date" format="MM/dd/yyyy" placeholder="To Date"></el-date-picker>
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-2">
                <label for="searchProjectType">Status</label>
            </div>
            <div class="col-sm-3">
                <select class="form-control" name="workflowStatusId" v-model="searchDto.workflowStatusId">
                    <option :value="null">Select Workflow Status</option>
                    <option v-for="status in fwrWorkflowList" :value="status.workflowStatusId" :key="status.workflowStatusId">{{status.description}}</option>
                </select>
            </div>
        </div>
        <div class="form-group form-check">
            <div class="col-sm-2">
                <label class="form-check-label" for="showInactive">Show Inactives</label>
            </div>
            <div class="col-sm-4">
                <input class="form-check-input" type="checkbox" v-model="searchDto.showInactive" style="width: 20px; height: 20px;">
            </div>
        </div>
        <div class="form-group">
            <div class="col-md-2">
                <button class="btn btn-primary" type="submit" name="button" v-on:click="loadData">Search</button>
            </div>
        </div>
    </form>
    <div class="wrapper">
      <div  class="row row-wider">
        <div class="col-md-12">
          <loader v-if="loading"></loader>
          <div>
            <v-client-table :data="gridSpec.tableData" :columns="gridSpecColumns" :options="gridSpec.options" ref="fwrTable">
              <template slot="edit" slot-scope="props">
                <div style="text-align: center;">
                    <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editRow(props.row.fieldworkRequestId)"></a> -->
                    <router-link :to="{ path: '/FieldWorkRequest/' + props.row.fieldworkRequestId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                </div>
              </template>
            </v-client-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import fieldworkRequestService from '../services/fieldworkRequestService'
import organizationService from '../services/organizationService'
import workflowService from '../services/workflowService'

import loader from '../components/Loader.vue'

export default {
    components: {
        loader
    },
    props: {
        type: {
            type: String,
            default: 'search'
        }
    },
    data () {
        return {
            isDebug: false,
            loading: true,
            list: null,
            leadOrganizationList: [],
            organizationList: [],
            searchDto: {
                description: null,
                dbNumber: '',
                projectName: '',
                agencyProjectNumber: '',
                agencyName: '',
                fieldOrgProjectNumber: '',
                fieldOrgName: '',
                projectType: '',
                startDate: null,
                endDate: null,
                workflowStatusId: null,
                showInactive: false
            },
            gridSpec: {
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate', 'proposedStartDate', 'proposedEndDate', 'workflowStatusDate'],
                    headings: {
                        edit: 'View/Edit',
                        dbNumber: 'DB Number',
                        createdDate: 'Date Created',
                        workflowStatusDescription: 'Status',
                        workflowStatusDate: 'Status Date',
                        projectName: 'Project',
                        projectTypeDescription: 'Project Type',
                        fieldOrganizationDescription: 'Field Org',
                        fieldOrganizationProjectNumber: 'Field Org. Project No.',
                        agencyDescription: 'Lead Agency',
                        proposedStartDate: 'Field Start',
                        submitDate: 'Date Requested'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'workflowStatusDate'
                    }
                }
            },
            fwrWorkflowList: []
        }
    },
    computed: {
        gridSpecColumns: function () {
            var gridSpecColumns = ['edit',
                'dbNumber',
                'workflowStatusDescription',
                'workflowStatusDate',
                'createdDate',
                'submitDate',
                'projectName',
                'projectTypeDescription',
                'fieldOrganizationDescription',
                'fieldOrganizationProjectNumber',
                'agencyDescription',
                'proposedStartDate']
            if (this.type === 'search') {
                loggingService.log(this.isDebug, 'FieldworkRequests', 'computed.gridSpec.search')
            } else if (this.type === 'todo') {
                loggingService.log(this.isDebug, 'FieldworkRequests', 'computed.gridSpec.todo')
                gridSpecColumns.push('isUserAssignedDisplay')
                this.gridSpec.options.headings.isUserAssignedDisplay = 'Assigned'
            } else {
                loggingService.log(this.isDebug, 'FieldworkRequests', 'computed.gridSpec - unknown type: ' + this.type)
            }
            return gridSpecColumns
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'FieldworkRequests', 'mounted')

        this.loadData()
        this.loadWorkflow()
        this.loadLeadOrganizationList()
        this.loadOrganizations()
    },
    methods: {
        loadData () {
            loggingService.log(this.isDebug, 'FieldworkRequests', 'loadData, type: ' + this.type)

            var handle = this
            handle.list = null

            // clear out gridSpec tableData

            if (this.type === 'search') {
                fieldworkRequestService.search(this.$http, this.searchDto).then(function (response) {
                    loggingService.log(handle.isDebug, 'FieldworkRequests', 'fieldworkRequestService.loadData.search.then')

                    handle.gridSpec.tableData = response.data
                    handle.loading = false
                })
            } else if (this.type === 'todo') {
                fieldworkRequestService.todo(this.$http, this.searchDto).then(function (response) {
                    loggingService.log(handle.isDebug, 'FieldworkRequests', 'fieldworkRequestService.loadData.todo.then')

                    handle.gridSpec.tableData = response.data
                    handle.loading = false
                })
            } else {
                loggingService.log(handle.isDebug, 'FieldworkRequests', 'fieldworkRequestService.loadData - unknown type: ' + this.type)
            }
            handle.$refs.fwrTable.setData
        },
        loadWorkflow () {
            workflowService.listByWorkflowId(this.$http, workflowService.WorkflowEnum.FieldworkRequest).then(result => {
                this.fwrWorkflowList = result.data.reverse()
            })
        },
        loadLeadOrganizationList () {
            loggingService.log(this.isDebug, 'FieldworkRequests', 'loadLeadOrganizationList')
            this.leadOrganizationList = []
            var handle = this
            return organizationService.listLeadAgencyLookup(handle.$http).then(function (response) {
                handle.leadOrganizationList = response.data
            })
        },
        loadOrganizations () {
            loggingService.log(this.isDebug, 'FieldworkRequests', 'loadOrganizations')
            this.organizationList = []
            var handle = this
            return organizationService.listLookup(this.$http).then(function (response) {
                handle.organizationList = response.data
            })
        },
        editRow (id) {
            loggingService.log(this.isDebug, 'FieldworkRequests', 'editRow: ' + id)
            this.$router.push('/FieldWorkRequest/' + id)
        }
    }
}
</script>



// WEBPACK FOOTER //
// FieldworkRequests.vue?142452f2